//引入Vue核心库
import Vue from 'vue'
//引入Vuex
import Vuex from 'vuex'
import {
    getPrintElementTypeGroup, getTemplateContentById, getPrintElementTypeGroup2
} from '@/api'
import other from './other'
import f1 from './f1'
import f2 from './f2'
//应用Vuex插件
Vue.use(Vuex)
//准备state对象——保存具体的数据
const state = {
    printElementTypeGroup: [],
    // 打印所处的状态 0初始 1拖拽组件完成 
    printStatus: 0,
    query: {},
    template: null,
    templateStatus: 0,
    column: {},
    footerFormatter: '',
    //水平偏移
    MyOffsetX: 0,
    //垂直偏移
    MyOffsetY: 0,
    //页边距
    pageTop: 0,
    pageLeft: 5,
    pageRight: 5,
    pageBottom: 0,
    maxTableWidth: 0,
}
function initState() {
    state.printElementTypeGroup = [];
    state.printStatus = 0;
    state.query = {};
    state.template = null;
    state.templateStatus = 0;
    state.column = {};
    state.footerFormatter = '';
    //水平偏移
    state.MyOffsetX = 0;
    //垂直偏移
    state.MyOffsetY = 0;
    //页边距
    state.pageTop = 0;
    state.pageLeft = 5;
    state.pageRight = 5;
    state.pageBottom = 0;
    state.maxTableWidth = 0;
}
const getters = {
    token: state => state.query.token,
    sourceUrl: state => state.query.sourceUrl.replace(/%2F/g, '/'),
    templateId: state => state.query.templateId,
    columns: state => state.printElementTypeGroup?.[2]?.elementType?.[0]?.options?.column?.[0]
}
//准备actions对象——响应组件中用户的动作
const actions = {
    async init(context) {
        initState();
        //获取search参数
        let search = window.location.search
        //判断是否有search参数
        if (search) {
            //截取search参数
            search = search.substring(1)
            //将search参数转换为数组
            let searchArr = search.split('&')
            let query = {}
            //遍历数组
            for (let i = 0; i < searchArr.length; i++) {
                query[searchArr[i].split('=')[0]] = searchArr[i].split('=')[1]
            }
            //将query对象保存到state中
            context.state.query = query;
            //获取打印元素类型组
            let res = await getPrintElementTypeGroup(query.sourceUrl)
            let footerFormatter = f1;
            //将打印元素类型组保存到state中
            if (res.code != 200) {
                res = await getPrintElementTypeGroup2(query.sourceUrl)
            }

            // if (res.code == 200) {
            if (true) {
                let drag = res.data;
                if (query.sourceUrl.replace(/%2F/g, '/') == '/hiPrint/getHiPrintResourceByCatId/assembly' || query.sourceUrl.replace(/%2F/g, '/') == '/hiPrint/getHiPrintResourceByCatId/dispatch' || query.sourceUrl.replace(/%2F/g, '/') == '/hiPrint/getHiPrintResourceByCatId/inventory') {
                    drag.forEach((item) => {
                        item.elementType.forEach((elementTypeItem) => {
                            if (elementTypeItem.type == 'text') {
                                elementTypeItem.options.width = 180;
                                elementTypeItem.options.height = 10.5;
                                elementTypeItem.options.title = elementTypeItem.title;
                                elementTypeItem.options.formatter = "function (title,value,option,templateData){return templateData?.bill[option.field]||option.testData;}";
                                elementTypeItem.options.field = elementTypeItem.options.field;
                                elementTypeItem.options.testData = '@' + elementTypeItem.title;
                                elementTypeItem.options.fontFamily = "微软雅黑";
                                elementTypeItem.options.fontSize = 10.5;
                                elementTypeItem.options.fontWeight = "normal";
                                elementTypeItem.options.textDecoration = "none";
                                elementTypeItem.options.textAlign = "left";
                                elementTypeItem.options.textContentVerticalAlign = "middle";
                                elementTypeItem.options.textType = "text";
                                elementTypeItem.options.hideTitle = false;
                                elementTypeItem.options.styler = "function (value,options){return {fontStyle:options.fontStyle}}";
                                if(elementTypeItem.options.field == 'totalPrice'){
                                    elementTypeItem.options.formatter = "function (title,value,option,templateData){return templateData?.bill[option.field]?hinnn.toUpperCase('7',templateData?.bill[option.field]):option.testData;}";
                                }
                            }
                        })

                    })
                } else {
                    drag.forEach((item) => {
                        item.elementType.forEach((elementTypeItem) => {
                            if (elementTypeItem.type == 'text') {
                                elementTypeItem.options.width = 180;
                                elementTypeItem.options.height = 10.5;
                                elementTypeItem.options.title = elementTypeItem.title;
                                elementTypeItem.options.field = elementTypeItem.options.field;
                                elementTypeItem.options.testData = '@' + elementTypeItem.title;
                                elementTypeItem.options.fontFamily = "微软雅黑";
                                elementTypeItem.options.fontSize = 10.5;
                                elementTypeItem.options.fontWeight = "normal";
                                elementTypeItem.options.textDecoration = "none";
                                elementTypeItem.options.textAlign = "left";
                                elementTypeItem.options.textContentVerticalAlign = "middle";
                                elementTypeItem.options.textType = "text";
                                elementTypeItem.options.hideTitle = false;
                                elementTypeItem.options.styler = "function (value,options){return {fontStyle:options.fontStyle}}";

                            }
                            if (elementTypeItem.options.field == 'totalPrice') {

                                elementTypeItem.options.formatter = "function (title,value,option,templateData){ console.log('@1@',title,value,option,templateData); return typeof value =='number' ?hinnn.toUpperCase('7',value) : value;}";   
                            }

                        })
                    })
                }
                //改变表格
                drag.forEach((item) => {
                    item.elementType.forEach((elementTypeItem) => {
                        if (elementTypeItem.type == 'table') {


                            elementTypeItem.editable = null;
                            elementTypeItem.columnDisplayEditable = null;
                            elementTypeItem.columnDisplayIndexEditable = null;
                            elementTypeItem.columnTitleEditable = null;
                            elementTypeItem.columnResizable = null;
                            elementTypeItem.columnAlignEditable = null;
                            elementTypeItem.isEnableEditField = null;
                            elementTypeItem.isEnableContextMenu = null;
                            elementTypeItem.isEnableInsertRow = null;
                            elementTypeItem.isEnableDeleteRow = null;
                            elementTypeItem.isEnableInsertColumn = null;
                            elementTypeItem.isEnableDeleteColumn = null;
                            elementTypeItem.isEnableMergeCell = null;


                            elementTypeItem.options.styler = "function f(value, row, data, pageData) {\n  if (row.tableStyle == 'style1') {\n    return {};\n  } else if (row.tableStyle == 'style2') {\n    return {\n      border: 0,\n      borderTop: '1px dashed #000'\n    };\n  } else {\n    return {};\n  }\n}";
                            elementTypeItem.options.height = 97;
                            // elementTypeItem.options.width = 580;
                            elementTypeItem.options.fontFamily = "微软雅黑";
                            elementTypeItem.options.fontSize = 10.5;
                            elementTypeItem.options.textAlign = "center";
                            elementTypeItem.options.tableHeaderFontWeight = "normal";
                            elementTypeItem.options.tableBodyRowHeight = 24;
                            elementTypeItem.options.tableHeaderRowHeight = 24;
                            elementTypeItem.options.tableBodyRowBorder = "border";
                            elementTypeItem.options.tableHeaderBorder = "border";
                            elementTypeItem.options.tableBorder = "border";
                            elementTypeItem.options.tableHeaderCellBorder = "border";
                            elementTypeItem.options.tableBodyCellBorder = "border";
                            elementTypeItem.options.column = elementTypeItem.columns;
                            elementTypeItem.columns = [[]];


                            elementTypeItem.options.tableCompute1 = true;
                            elementTypeItem.options.tableCompute2 = true;
                            elementTypeItem.options.computeUpState = true;
                            elementTypeItem.options.tableComputeNumberState = true;
                            elementTypeItem.options.tableStyle = "style1";
                            elementTypeItem.options.editing = true;
                            elementTypeItem.options.width = 0;

                            elementTypeItem.options.column[0].forEach((item, index) => {
                                if (item.field == 'seq') {
                                    item.formatter2 = "function f(a,b,i){ return i + 1 }";
                                    item.tableTextType = "sequence";
                                    item.fixed = false;
                                    item.columnId = "seq";


                                } else {

                                    if (item.field == 'totalPrice' || item.field == 'total') {
                                        console.log("item.field == 'totalPrice'", item.field == 'totalPrice');
                                        item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                                    } else if (item.field == 'price') {
                                        item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                                    }else if (item.field == 'totalPriceTax') {
                                        item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                                    }else if (item.field == 'taxAmount') {
                                        item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                                    }
                                    else if (item.field =='priceDef') {
                                        item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                                    } else if (item.field == 'priceTax') {
                                        item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                                    }   
                                    else {
                                        item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return _; }`;
                                    }



                                    item.tableTextType = null;
                                    item.fixed = false;
                                    item.columnId = item.field;
                                }

                                if (typeof item.checked !== 'boolean') {
                                    item.checked = true;
                                }
                                if (item.checked) {
                                    elementTypeItem.columns[0].push(item);
                                    elementTypeItem.options.width += item.width;
                                }
                                footerFormatter = f1
                                context.state.footerFormatter = footerFormatter;
                                if (item.field == 'totalPrice') {
                                    footerFormatter = f1
                                    context.state.footerFormatter = footerFormatter;
                                }
                                if (item.field == 'total') {
                                    footerFormatter = f1
                                    context.state.footerFormatter = footerFormatter;
                                    item.field = 'totalPrice';

                                    item.columnId = 'totalPrice';
                                }
                                if (item.field == 'totalPrice' && item.title == '大写金额') {
                                    item.field = 'totalPrice2';
                                    item.columnId = 'totalPrice2';
                                }

                            })
                            if (elementTypeItem.options.width > 564) {
                                elementTypeItem.options.width = 564;
                            }
                            if (elementTypeItem.options.column[0].length == 0) {
                                elementTypeItem.options.column[0].unshift({
                                    "width": 30,
                                    "title": "序号",
                                    "field": "seq",
                                    "columnId": "seq",
                                    "checked": false,
                                    "fixed": false,
                                    "formatter2": "function f(a,b,i){ return i + 1 }",
                                    "tableTextType": "sequence",
                                    "rowspan": 1,
                                    "colspan": 1
                                })
                            }
                            if (elementTypeItem.options.column[0][0].field != 'seq') {
                                elementTypeItem.options.column[0].unshift({
                                    "width": 30,
                                    "title": "序号",
                                    "field": "seq",
                                    "columnId": "seq",
                                    "checked": false,
                                    "fixed": false,
                                    "formatter2": "function f(a,b,i){ return i + 1 }",
                                    "tableTextType": "sequence",
                                    "rowspan": 1,
                                    "colspan": 1
                                })
                            }
                            if (elementTypeItem.columns[0].length == 0) {
                                elementTypeItem.options.column[0].checked = true;
                                elementTypeItem.columns[0].push({
                                    "width": 30,
                                    "title": "序号",
                                    "field": "seq",
                                    "columnId": "seq",
                                    "checked": true,
                                    "fixed": false,
                                    "formatter2": "function f(a,b,i){ return i + 1 }",
                                    "tableTextType": "sequence",
                                    "rowspan": 1,
                                    "colspan": 1
                                })
                                elementTypeItem.options.width = 30;

                            }

                            elementTypeItem.options.footerFormatter = footerFormatter;

                            context.state.column[elementTypeItem.options.field] = elementTypeItem.options.column;
                        }
                    })

                })
                drag.push(other)
                context.state.printElementTypeGroup = drag

            }
            // context.state.printElementTypeGroup = res.data;
            let template = await getTemplateContentById(query.templateId)
            //将打印元素类型组保存到state中
            
            template.data?.panels[0]?.printElements?.forEach((item, index) => {
                if (item.printElementType.type == 'table') {
                    item.options.column = context.state.column[item.options.field]  ;
                    item.options.editing = true;
                    item.options.column[0].forEach((item, index) => {
                        if (item.field == 'totalPrice' || item.field == 'total') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)  ); }`;
                        } else if (item.field == 'price') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)  ); }`;
                        }else if (item.field == 'totalPriceTax') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)  ); }`;
                        }else if (item.field == 'taxAmount') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)  ); }`;
                        } else if (item.field =='priceDef') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)  ); }`;
                        } else if (item.field == 'priceTax') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)  ); }`;
                        }   

                    })
                    item.options.columns[0].forEach((item, index) => {
                        if (item.field == 'totalPrice' || item.field == 'total') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                        } else if (item.field == 'price') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                        }else if (item.field == 'totalPriceTax') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                        }else if (item.field == 'taxAmount') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                        } else if (item.field =='priceDef') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                        } else if (item.field == 'priceTax') {
                            item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (_?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
                        }   
                    })
                    let newColumns = [];
                    item.options.columns[0].forEach((item, index) => {
                        if ((typeof item.checked=== 'boolean' && item.checked) || item.checked == undefined ) {
                            newColumns.push(item);
                        }
                    })
                    item.options.columns[0] = newColumns;
                    item.options.footerFormatter = f1;
                }
                if (item.options.field == 'totalPrice') {

                    item.options.formatter = "function (title,value,option,templateData){ console.log('@1@',title,value,option,templateData); return typeof value =='number' ?hinnn.toUpperCase('7',value) : value;}";   
                }
            })
            context.state.template = template.data;
            context.state.templateStatus = 1;

            //如果是小票
            if (query.sourceUrl.replace(/%2F/g, '/') == '/hiPrint/getHiPrintResourceByCatId/label') {
                context.state.pageLeft = 1;
                context.state.pageRight = 0;
            }


        }

    },
}
//准备mutations对象——修改state中的数据
const mutations = {
    changePrintStatus(state, status) {
        state.printStatus = status;
    },
    PIANYI(state, { MyOffsetX, MyOffsetY, pageTop, pageLeft, pageRight, pageBottom }) {
        console.log('staMyOffsetX', MyOffsetX, MyOffsetY, pageTop, pageLeft, pageRight, pageBottom);
        console.log('staMyOffsetX', state.MyOffsetX, state.MyOffsetY, state.pageTop, state.pageLeft, state.pageRight, state.pageBottom);
        state.MyOffsetX = typeof MyOffsetX === 'number' ? MyOffsetX : state.MyOffsetX;
        state.MyOffsetY = typeof MyOffsetY === 'number' ? MyOffsetY : state.MyOffsetY;
        state.pageTop = typeof pageTop === 'number' ? pageTop : state.pageTop;
        state.pageLeft = typeof pageLeft === 'number' ? pageLeft : state.pageLeft;
        state.pageRight = typeof pageRight === 'number' ? pageRight : state.pageRight;
        state.pageBottom = typeof pageBottom === 'number' ? pageBottom : state.pageBottom;

    },
    MAXTABLEWIDTH(state, maxTableWidth) {
        state.maxTableWidth = maxTableWidth;
    }

}


//创建并暴露store
export default new Vuex.Store({
    actions,
    mutations,
    state,
    getters
})